import create from 'zustand';
import { Disciple } from '../screens/report/screen/vision2028/types/disciple';
import { DiscipleType } from '../screens/report/screen/vision2028/types/disciple';

interface DiscipleStoreState {
  disciples: Disciple[];

  // 액션
  addDisciple: (disciple: Disciple, discipleTypes: DiscipleType[]) => void;
  removeDisciple: (index: number) => void;
  setDisciples: (disciples: Disciple[]) => void;
  clearDisciples: () => void;
}

/**
 * 제자 관리 스토어
 * 월간 보고서와 완전히 별개로 관리되는 제자 리스트
 */
export const useDiscipleStore = create<DiscipleStoreState>((set) => ({
  disciples: [],

  /**
   * 제자 추가 (추가 후 제자종류별, 이름별로 정렬)
   */
  addDisciple: (disciple, discipleTypes) => {
    set((state) => {
      const list = [...state.disciples, disciple];

      // 제자종류로 정렬 (같은 제자종류 내에서는 이름으로 정렬)
      list.sort((a, b) => {
        const aLabel = discipleTypes.find((opt) => opt.id === a.typeId)?.displayName || '';
        const bLabel = discipleTypes.find((opt) => opt.id === b.typeId)?.displayName || '';

        if (aLabel !== bLabel) {
          return aLabel.localeCompare(bLabel, 'ko');
        }
        return a.name.localeCompare(b.name, 'ko');
      });

      return { disciples: list };
    });
  },

  /**
   * 제자 삭제
   */
  removeDisciple: (index) => {
    set((state) => ({
      disciples: state.disciples.filter((_, i) => i !== index),
    }));
  },

  /**
   * 제자 리스트 전체 설정
   */
  setDisciples: (disciples) => set({ disciples }),

  /**
   * 제자 리스트 초기화
   */
  clearDisciples: () => set({ disciples: [] }),
}));
